<template>
  <section id=intro class="intro scene dark min-height-full" ref="intro">
    <a href=#music class="arrow bounce"></a>
    <h1 class="hidden">Eight Bit Tiger</h1>
    <span class="icon-logo"></span>
    <span class="icon-logo"></span>
    <span class="icon-logo"></span>
    <span class="icon-logo"></span>
    <span class="icon-logo"></span>
    <span class="icon-logo"></span>
    <span class="icon-logo"></span>
    <span class="icon-logo"></span>
    <span class="icon-logo"></span>
    <span class="icon-logo"></span>
    <span class="icon-logo"></span>
    <span class="icon-logo"></span>
  </section>
</template>

<script>
export default {
  name: 'Intro',
  data() {
    return {
      c: window,
      d: document,
      x: 0,
      y: 0,
      w: 500,
      h: 500,
      scrollTop: 0,
      animation: true,
      changeColor: false,
      colors: [],
      f: [],
    };
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    this.onResize();

    window.addEventListener('scroll', this.onScroll);
    this.onScroll();

    this.f = this.$refs.intro.getElementsByClassName('icon-logo');

    for (let i = 0, l = this.f.length; i < l; i += 1) {
      this.colors.unshift(this.randomColor());
    }
    window.requestAnimationFrame(this.onAnimationFrame);

    this.setupInteractionCallbacks();

    setInterval(this.setChangeColorTrue, 40);
  },
  methods: {
    randomColor() {
      let randomHex = Math.floor(Math.random() * 16777215).toString(16);

      while (/^[0-9a-fA-F]{6}$/i.test(randomHex) === false) {
        randomHex = Math.floor(Math.random() * 16777215).toString(16);
      }

      return `#${randomHex}`;
    },
    setChangeColorTrue() {
      this.changeColor = true;
    },
    oscillator(time, frequency) {
      return Math.sin(time * 2 * Math.PI * frequency);
    },
    onScroll() {
      // turn off animation when it's out of frame.
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.scrollTop > this.h) {
        if (this.animation) {
          this.animation = false;
        }
      } else {
        this.animation = true;
        window.requestAnimationFrame(this.onAnimationFrame);
      }
    },
    onResize() {
      this.h = window.innerHeight;
      this.w = window.innerWidth;
    },
    isTouchDevice() {
      return (('ontouchstart' in window)
        || (navigator.maxTouchPoints > 0)
        || (navigator.msMaxTouchPoints > 0));
    },
    onTouch(a) {
      if (a.targetTouches.length === 1) {
        const b = a.targetTouches[0];
        this.x = b.pageX;
        this.y = b.pageY;
      }
    },
    onMouseMove(a) {
      this.x = a.pageX;
      this.y = a.pageY;
    },
    setupInteractionCallbacks() {
      if (this.isTouchDevice()) {
        this.$refs.intro.addEventListener('touchmove', this.onTouch, false);
      } else {
        this.$refs.intro.addEventListener('mousemove', this.onMouseMove);
      }
    },
    onAnimationFrame() {
      if (this.changeColor) {
        this.changeColor = false;
        const color = this.randomColor();
        this.colors.pop();
        this.colors.unshift(color);
      }

      for (let d = 0, l = this.f.length; d < l; d += 1) {
        const g = -50 + 0.05 * (this.w / 2 - this.x) * (0.1 * (d + 4));
        const j = -50 + 0.3 * (this.h / 2 - this.y) * (0.1 * (d + 4));

        this.f[d].style.transform = `translate(${g}%, ${j}%)`;
        this.f[d].style.color = this.colors[d];
      }

      if (this.animation) {
        window.requestAnimationFrame(this.onAnimationFrame);
      }
    },
  },
};
</script>
